import { render, staticRenderFns } from "./OrderListnew.vue?vue&type=template&id=65a4090c&scoped=true&"
import script from "./OrderListnew.vue?vue&type=script&lang=js&"
export * from "./OrderListnew.vue?vue&type=script&lang=js&"
import style0 from "./OrderListnew.vue?vue&type=style&index=0&id=65a4090c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a4090c",
  null
  
)

export default component.exports